import {Select, TableSearchInput} from '@/components';

import SubTabs from '../SubTabs';
import type {BalanceFilter, BalanceSort} from '../types';

type BusinessBalanceFiltersProps = {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filter: BalanceFilter;
  onFilterChange: (value: BalanceFilter) => void;
  counts: Record<BalanceFilter, number>;
  sort: BalanceSort;
  onSortChange: (value: BalanceSort) => void;
};

const sortOptions: {key: string; value: BalanceSort}[] = [
  {key: 'Fee debt first', value: 'debt'},
  {key: 'Currency A to Z', value: 'code'},
  {key: 'Largest payout', value: 'payout'},
];

const BusinessBalanceFilters = ({
  searchTerm,
  onSearchChange,
  filter,
  onFilterChange,
  counts,
  sort,
  onSortChange,
}: BusinessBalanceFiltersProps) => (
  <div className="flex w-full flex-col gap-3 lg:flex-row lg:flex-wrap lg:items-center">
    {/* TableSearchInput sets sm:w-64 on the input; sm:w-full overrides it so
        the box stays full width until the row layout kicks in. */}
    <TableSearchInput
      value={searchTerm}
      onChange={onSearchChange}
      placeholder="Find a currency"
      className="sm:w-full lg:w-60"
    />
    <SubTabs
      className="pt-0"
      dataCy="business-details-balances-filter"
      activeId={filter}
      onChange={(id) => onFilterChange(id as BalanceFilter)}
      tabs={[
        {id: 'funded', label: `With a balance ${counts.funded}`},
        {id: 'owing', label: `Owes fees ${counts.owing}`},
        {id: 'all', label: `All ${counts.all}`},
      ].map((tab) => ({...tab, content: null}))}
    />
    <div className="flex items-center gap-3 lg:ml-auto">
      <p className="shrink-0 text-sm text-gray-500 dark:text-gray-400">Sort</p>
      <Select
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          onSortChange(e.target.value as BalanceSort)
        }
        value={sort}
        name="sort"
        dataCy="business-details-balances-sort"
        options={sortOptions}
        placeholder="Sort by"
        className="w-full lg:w-48"
      />
    </div>
  </div>
);

export default BusinessBalanceFilters;
